import { lazy, Suspense } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LayoutSplashScreen, ContentRoute } from "../_metronic/layout";
import { DashboardPage } from "./pages/DashboardPage";
import SupplierProfile from "./pages/management/SupplierProfile/Index";
import TicketSearch from "./pages/TicketManagement/TicketSearch";
import TicketList from "./pages/TicketManagement/TicketList";

// import ChangePassword from "./pages/Auth/ChangePassword";
// import PromoCode from './pages/customers/PromoCode/Index';
// import PublicPromoCode from './pages/customers/PublicPromoCode/Index';
// import UsedPromoCodeByUser from './pages/customers/UsedPromoCodeByUser/Index';
import Withdrawals from "./pages/Wallet/Withdrawals/Index";
import Accounts from "./pages/Wallet/Accounts/Index";
import UserTransactions from "./pages/Wallet/UserTransactions/Index";
import EditAgentCommissionItems from "./pages/AgentCommision/EditCommissionGroupItems";
import AgentCommision from "./pages/AgentCommision/Index";
import SupplierAgentCommission from "./pages/AssignCommissionGroupToSupplier/Index";
import ChangePassword from "./pages/Auth/ChangePassword";
import SellReport from "./pages/Reports/SellReport/Index"
// import KishPortInfo from "./pages/Services/KishPortInfo/Index";
// import { CreateEditKishPortInfo } from './pages/Services/KishPortInfo/CreateOrEdit';
const Learn = lazy(() => import("./pages/Learn"))

export default function BasePage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Routes>
        {/* Redirect from root URL to /dashboard */}
        <Route path="/" element={<Navigate to="/dashboard" replace />} />

        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/supplierProfile" element={<SupplierProfile />} />
        <Route path="/ticketSearch" element={<TicketSearch />} />
        <Route path="/ticketVoidingGuide" element={<Learn />} />


        {/* <Route
          path="/TicketStatusToUsedConfirmed"
          element={<TicketStatusToUsedConfirmed />}
        /> */}
        {/* <Route path="/changePassword" element={<ChangePassword />} /> */}
        {/* <Route path="/promoCode" element={<PromoCode />} /> */}
        {/* <Route path="/publicPromoCode" element={<PublicPromoCode />} /> */}
        <Route path="/ticketList" element={<TicketList />} />
        <Route path="/supllierWithdrawals" element={<Withdrawals />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/userTransactions" element={<UserTransactions />} />
        <Route path="/agentCommissions" element={<AgentCommision />} />
        <Route
          path="/createOrEditAgentCommision/:id"
          element={<EditAgentCommissionItems />}
        />
        <Route
          path="/supplierAgentCommissions"
          element={<SupplierAgentCommission />}
        />
        <Route path="/changePassword" element={<ChangePassword />} />
        {/* <Route path="/kishPortInfo" element={<KishPortInfo />} />
        <Route path="/createOrEditKishPortInfo/:id?" element={<CreateEditKishPortInfo />} />  */}
        <Route path="/sellReport" element={<SellReport />} />
        {/* Redirect to error page */}
        <Route path="*" element={<Navigate to="error/error-v1" replace />} />
      </Routes>
    </Suspense>
  );
}
